<template>
  <div>
    <span>
      <span class="nowrap font-weight-medium" v-if="haveMultipleCurrencies">
        <InfoTooltip
          :text="$t('common.calculatedPrice')"
        />
        {{ $t('common.calculated', { value: $options.filters.formatCurrency(sumMulti, currencyForFormatting) }) }}
      </span>
      <span class="nowrap font-weight-medium" v-else> {{ sumSingle | formatCurrency(currencyForFormatting) }}</span>
      <span v-if="percentText" class="nowrap font-weight-medium"> {{ percentText }} </span>
      <span class="nowrap" v-if="!isInChosenCurrency">
        ({{ prices[itemCurrency.key] || prices | formatCurrency({ key: itemCurrency.key, value: 1}) }})
      </span>
    </span>
    <div class="mb-2" v-if="haveMultipleCurrencies">
      <p
        v-for="currencyCode in Object.keys(prices).filter(i => i !== 'sum')"
        :key="currencyCode"
        class="nowrap text--secondary mb-0"
      >
        {{ prices[currencyCode] | formatCurrency({ key: currencyCode, value: 1 }) }}
      </p>
    </div>
  </div>
</template>

<script>
import { calculateBaseCurrencyCentsToChosen } from '../../helpers'
export default {
  name: 'PricesDisplay',
  props: {
    prices: {
      type: [Object, Number],
      default: () => ({})
    },
    contractCurrencies: Array,
    chosenCurrency: {
      type: Object,
      default: () => ({ key: '', value: 1 })
    },
    itemCurrency: {
      type: Object,
      default: () => ({ key: '', value: 1 })
    },
    percentText: String
  },
  data () {
    return {}
  },
  computed: {
    haveMultipleCurrencies () {
      return isNaN(this.prices) && (Object.keys(this.prices).filter(i => i !== 'sum' && i !== this.itemCurrency.key).length > 0)
    },
    isInChosenCurrency () {
      return this.itemCurrency.key ? this.itemCurrency.key === this.chosenCurrency.key : true
    },
    isChosenCurrencySameAsBase () {
      return this.chosenCurrency.key === this.baseCurrency.key
    },
    sumMulti () {
      return calculateBaseCurrencyCentsToChosen(this.prices.sum, this.baseCurrency, this.chosenCurrency)
    },
    sumSingle () {
      if (this.isChosenCurrencySameAsBase) {
        return isNaN(this.prices) ? this.prices.sum : this.prices * this.itemCurrency.value
      }
      if (this.itemCurrency.key === this.baseCurrency.key) {
        return isNaN(this.prices) ? this.prices[this.itemCurrency.key] / this.chosenCurrency.value : this.prices / this.chosenCurrency.value
      }
      if (this.itemCurrency.key === this.chosenCurrency.key) {
        return isNaN(this.prices) ? this.prices[this.itemCurrency.key] : this.prices
      }
      return isNaN(this.prices) ? this.prices[this.itemCurrency.key] * this.itemCurrency.value / this.chosenCurrency.value : this.prices * this.itemCurrency.value / this.chosenCurrency.value
    },
    baseCurrency () {
      return this.contractCurrencies ? this.contractCurrencies[0] : {}
    },
    currencyForFormatting () {
      return { ...this.chosenCurrency, value: 1 }
    }
  }
}
</script>
